import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DatePicker from "react-datepicker";
import {
  addClusterAccess,
  addClusterdetails,
  addClusterStore,
  changeSettingValue,
  getClusterModules,
  saveClusterdetails,
  showAlert,
} from "../../../Redux/actions";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import ErrorContainer from "../../Components/ErrorContainer";
import { changeDateFormat, checkArray, checkNull } from "../../../helpers";
import LoadingBtn from "../../Components/LoadingBtn";
import ModelContainer from "../../Components/ModelContainer";
import moment from "moment";

const addClusterSchema = yup
  .object({
    cluster_id: yup.string().nullable(),
    cluster_name: yup.string().required(),
    user_id: yup.string().required(),
    status: yup.string().required(),
    payroll_access: yup.string().required(),
  })
  .required();

const addClusSettingsSchema = yup
  .object({
    id: yup.string().nullable(),
    cluster_module_id: yup.string().required(),
    cluster_module_method_id: yup.string().required(),
    authority_level: yup.string().required(),
    start_date: yup.string().required(),
    end_date: yup.string().required(),
  })
  .required();

const addClusStoreSchema = yup
  .object({
    id: yup.string().nullable(),
    merchant_id: yup.string().required(),
    start_date: yup.string().required(),
    end_date: yup.string().required(),
  })
  .required();

const AddCluster = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    add_cluster_details,
    is_save_cluster_loading,
    redirect_path,
    cluster_modules,
    selected_cluster_details,
    addClusSettingsModal,
    is_add_cluster_settings_loading,
    addClusStoreModal,
    is_add_cluster_store_loading,
  } = useSelector((state) => state.settingReducer);

  useEffect(() => {
    dispatch(addClusterdetails());

    return () => {
      dispatch(changeSettingValue("add_cluster_details", null));
      dispatch(changeSettingValue("selected_cluster_details", null));
      dispatch(changeSettingValue("redirect_path", ""));
      dispatch(changeSettingValue("cluster_modules", []));
    };
  }, []);

  useEffect(() => {
    if (redirect_path && redirect_path !== "") {
      history.push(redirect_path);
    }
  }, [redirect_path]);

  useEffect(() => {
    if (checkNull(selected_cluster_details?.id, false)) {
      resetAddClusterHandler(
        {
          cluster_name: selected_cluster_details?.cluster_name
            ? `${selected_cluster_details?.cluster_name}`
            : "",
          user_id: selected_cluster_details?.user_id
            ? `${selected_cluster_details?.user_id}`
            : "",
          status: selected_cluster_details?.status
            ? `${selected_cluster_details?.status}`
            : "",
          payroll_access: selected_cluster_details?.payroll_access
            ? `${selected_cluster_details?.payroll_access}`
            : "",
        },
        false
      );
    }
  }, [selected_cluster_details]);

  // add cluster
  const [addClusterInputForm, setAddClusterInputForm] = useState(
    initialAddClusterForm
  );

  const initialAddClusterForm = {
    cluster_name: "",
    user_id: "",
    status: "",
    payroll_access: "",
  };

  const changeAddClusterInputHandler = (input, val) => {
    addClusterSetValue(input, val);
    setAddClusterInputForm((prevState) => ({ ...prevState, [input]: val }));
  };

  const {
    register: addClusterReg,
    formState: { errors: addClusterErrors },
    handleSubmit: addClusterSubmit,
    control: addClusterControl,
    setValue: addClusterSetValue,
    reset: addClusterReset,
  } = useForm({
    resolver: yupResolver(addClusterSchema),
    defaultValues: initialAddClusterForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const submitAddClusterHandler = (data) => {
    if (checkNull(selected_cluster_details?.id, false)) {
      data.cluster_id = selected_cluster_details?.id;
    }
    console.log("submitAddClusterHandler", data);
    dispatch(saveClusterdetails(data));
  };
  const resetAddClusterHandler = (
    resetVal = initialAddClusterForm,
    redirectBack = true
  ) => {
    setAddClusterInputForm(resetVal);
    addClusterReset(resetVal);
    if (redirectBack) history.push("/settings/cluster-settings");
  };

  // add cluster settings

  const [addClusSettingsInputForm, setAddClusSettingsInputForm] = useState(
    initialAddClusSettingsForm
  );

  const initialAddClusSettingsForm = {
    id: "",
    cluster_module_id: "",
    cluster_module_method_id: "",
    authority_level: "",
    start_date: "",
    end_date: "",
  };

  const changeAddClusSettingsInputHandler = (input, val) => {
    if (input == "cluster_module_id") {
      initialAddClusSettingsModal({
        ...initialAddClusSettingsForm,
        cluster_module_id: val,
      });
      if (checkNull(val, false)) {
        dispatch(getClusterModules({ id: val }));
      } else {
        dispatch(changeSettingValue("cluster_modules", []));
      }
    } else {
      addClusSettingsSetValue(input, val);
      setAddClusSettingsInputForm((prevState) => ({
        ...prevState,
        [input]: val,
      }));
    }
  };

  const {
    register: addClusSettingsReg,
    formState: { errors: addClusSettingsErrors },
    handleSubmit: addClusSettingsSubmit,
    control: addClusSettingsControl,
    setValue: addClusSettingsSetValue,
    reset: addClusSettingsReset,
  } = useForm({
    resolver: yupResolver(addClusSettingsSchema),
    defaultValues: initialAddClusSettingsForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const submitAddClusSettingsHandler = (data) => {
    if (selected_cluster_details?.id) {
      data.cluster_id = selected_cluster_details?.id;
      data.start_date = changeDateFormat(data?.start_date, "yyyy-MM-DD");
      data.end_date = changeDateFormat(data?.end_date, "yyyy-MM-DD");
      console.log("submitAddClusSettingsHandler", data);
      dispatch(addClusterAccess(data));
    } else {
      dispatch(showAlert("Alert", `Please add cluster details first!`));
    }
  };

  const initialAddClusSettingsModal = (newVal = initialAddClusSettingsForm) => {
    setAddClusSettingsInputForm(newVal);
    addClusSettingsReset(newVal);
  };

  const closeAddClusSettingsModal = useCallback(
    (value) => {
      dispatch(changeSettingValue("addClusSettingsModal", value));
      initialAddClusSettingsModal();
    },
    [addClusSettingsModal]
  );

  const editClusSettingHandler = (access) => {
    closeAddClusSettingsModal(true);
    dispatch(getClusterModules({ id: access?.cluster_module_id }));
    const editClusSettingsForm = {
      id: access?.id,
      cluster_module_id: access?.cluster_module_id,
      cluster_module_method_id: access?.cluster_module_method_id,
      authority_level: access?.authority_level,
      start_date: moment(access?.start_date).toDate(),
      end_date: moment(access?.end_date).toDate(),
    };
    initialAddClusSettingsModal(editClusSettingsForm);
  };

  const getModuleNameByAccess = (access) => {
    let res = "";
    if (
      checkArray(add_cluster_details?.modules) &&
      add_cluster_details?.modules.findIndex(
        (p) => p?.id == access?.cluster_module_id
      ) > -1
    ) {
      const moduleIndex = add_cluster_details?.modules.findIndex(
        (p) => p?.id == access?.cluster_module_id
      );
      res = add_cluster_details?.modules?.[moduleIndex]?.name ?? "";
    }
    return res;
  };

  // add cluster store

  const [addClusStoreInputForm, setAddClusStoreInputForm] = useState(
    initialAddClusStoreForm
  );

  const initialAddClusStoreForm = {
    id: "",
    merchant_id: "",
    start_date: "",
    end_date: "",
  };

  const changeAddClusStoreInputHandler = (input, val) => {
    addClusStoreSetValue(input, val);
    setAddClusStoreInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };

  const {
    register: addClusStoreReg,
    formState: { errors: addClusStoreErrors },
    handleSubmit: addClusStoreSubmit,
    control: addClusStoreControl,
    setValue: addClusStoreSetValue,
    reset: addClusStoreReset,
  } = useForm({
    resolver: yupResolver(addClusStoreSchema),
    defaultValues: initialAddClusStoreForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const submitAddClusStoreHandler = (data) => {
    if (selected_cluster_details?.id) {
      data.cluster_id = selected_cluster_details?.id;
      data.start_date = changeDateFormat(data?.start_date, "yyyy-MM-DD");
      data.end_date = changeDateFormat(data?.end_date, "yyyy-MM-DD");
      console.log("submitAddClusStoreHandler", data);
      dispatch(addClusterStore(data));
    } else {
      dispatch(showAlert("Alert", `Please add cluster details first!`));
    }
  };

  const initialAddClusStoreModal = (newVal = initialAddClusStoreForm) => {
    setAddClusStoreInputForm(newVal);
    addClusStoreReset(newVal);
  };

  const closeAddClusStoreModal = useCallback(
    (value) => {
      dispatch(changeSettingValue("addClusStoreModal", value));
      initialAddClusStoreModal();
    },
    [addClusStoreModal]
  );

  const editClusStoreHandler = (store) => {
    const editClusStoreForm = {
      id: store?.id,
      merchant_id: store?.merchant_id,
      start_date: moment(store?.start_date).toDate(),
      end_date: moment(store?.end_date).toDate(),
    };
    initialAddClusStoreModal(editClusStoreForm);
    closeAddClusStoreModal(true);
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0">
          <div className="container px-0">
            <form onSubmit={addClusterSubmit(submitAddClusterHandler)}>
              <div className="top-header-sec py-3">
                <div class="row-fluid">
                  <div class="row pt-md-4 pt-2 pb-1">
                    <div class="col-md-6 col-12 d-flex align-items-center">
                      <h3 class="event-alert p-0 mb-0"> Cluster Details</h3>
                    </div>
                    <div class="col-md-6 col-12 align-right pt-3 pt-md-0">
                      <div class="shift_action report_add_buttons">
                        <LoadingBtn
                          is_loading={is_save_cluster_loading}
                          id="submitBut"
                          type="Submit"
                          className="btn btn_btnblue mx-3"
                        >
                          {checkNull(selected_cluster_details, false)
                            ? `Save Changes`
                            : `Create Cluster`}
                        </LoadingBtn>
                        <button
                          id="cancel"
                          type="button"
                          onClick={() => resetAddClusterHandler()}
                          class="btn cancel"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="shadowclass row gx-5 mx-0">
                  <div class="col-md-6 px-2">
                    <ul class="ingredient-info edit-shift">
                      <li>
                        <label class="required">Cluster Name</label>
                        <div class="input-group span7">
                          <input
                            {...addClusterReg("cluster_name")}
                            type="text"
                            id="ClusterClusterName"
                            value={addClusterInputForm?.cluster_name}
                            onChange={(e) =>
                              changeAddClusterInputHandler(
                                "cluster_name",
                                e?.target?.value
                              )
                            }
                          />{" "}
                          <ErrorContainer
                            errors={addClusterErrors}
                            name="cluster_name"
                          />
                        </div>
                      </li>
                      <li>
                        <label class="required">Cluster Manager</label>
                        <div class="input-group span7 select-div">
                          <select
                            {...addClusterReg("user_id")}
                            id="status"
                            value={addClusterInputForm?.user_id}
                            onChange={(e) =>
                              changeAddClusterInputHandler(
                                "user_id",
                                e?.target?.value
                              )
                            }
                          >
                            <option value="">Select</option>
                            {checkNull(add_cluster_details?.managers, false) &&
                              Object.keys(add_cluster_details?.managers).map(
                                (manager) => {
                                  return (
                                    <option value={manager}>
                                      {add_cluster_details?.managers?.[
                                        manager
                                      ] ?? ""}
                                    </option>
                                  );
                                }
                              )}
                          </select>{" "}
                          <ErrorContainer
                            errors={addClusterErrors}
                            name="user_id"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="col-md-6 px-2">
                    <ul class="ingredient-info edit-shift">
                      <li>
                        <label class="required">Status</label>
                        <div class="input-group select-div span7">
                          <select
                            {...addClusterReg("status")}
                            name="data[Cluster][status]"
                            class="cstatus"
                            id="ClusterStatus"
                            value={addClusterInputForm?.status}
                            onChange={(e) =>
                              changeAddClusterInputHandler(
                                "status",
                                e?.target?.value
                              )
                            }
                          >
                            <option value="">Select</option>
                            <option value="1">Active</option>
                            <option value="0">InActive</option>
                          </select>{" "}
                          <ErrorContainer
                            errors={addClusterErrors}
                            name="user_id"
                          />
                        </div>
                      </li>
                      <li>
                        <label class="required">Payroll Access?</label>
                        <div class="input-group select-div span7">
                          <select
                            {...addClusterReg("payroll_access")}
                            name="data[Cluster][payroll_access]"
                            id="ClusterPayrollAccess"
                            value={addClusterInputForm?.payroll_access}
                            onChange={(e) =>
                              changeAddClusterInputHandler(
                                "payroll_access",
                                e?.target?.value
                              )
                            }
                          >
                            <option value="">Select</option>
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>{" "}
                          <ErrorContainer
                            errors={addClusterErrors}
                            name="payroll_access"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div className="row mx-0 px-0">
            <div className="container px-0 pb-2">
              <div className="top-header-sec py-3">
                <div class="row-fluid">
                  <div class="row pt-0 pb-1">
                    <div class="col-md-6 col-12 d-flex align-items-center">
                      <h3 class="event-alert p-0 mb-0">
                        {" "}
                        Cluster Access Setting
                      </h3>
                    </div>
                    <div class="col-md-6 col-12 align-right pt-3 pt-md-0">
                      <button
                        className="btn green-btn-revert add-plus mx-0"
                        type="button"
                        onClick={() => {
                          if (selected_cluster_details == null) {
                            dispatch(
                              showAlert(
                                "Alert",
                                `Please add cluster details first!`
                              )
                            );
                          } else {
                            closeAddClusSettingsModal(true);
                          }
                        }}
                      >
                        <i className="i-icon"> </i> Add Cluster Access Settings
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="shadowclass py-0 mt-2">
                <div className="table-responsive">
                  <table className="checklist-table remove-space inventory_table m-0">
                    <thead>
                      <tr>
                        <th width="110px">Access Rule ID</th>
                        <th width="200px">Access Module</th>
                        <th width="210px">Action</th>
                        <th>Authority Level</th>
                        <th>Effective Start Date</th>
                        <th>Effective End Date</th>
                        <th className="action-td"> Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      {checkArray(
                        selected_cluster_details?.cluster_access_setting
                      ) &&
                        selected_cluster_details?.cluster_access_setting.map(
                          (access) => {
                            return (
                              <tr>
                                <td>{access?.id}</td>
                                <td>{getModuleNameByAccess(access)}</td>
                                <td>{access?.cluster_module_method?.name}</td>
                                <td>{access?.authority_level}</td>
                                <td>{access?.start_date}</td>
                                <td>{access?.end_date}</td>
                                <td className="action-td">
                                  <a
                                    onClick={() =>
                                      editClusSettingHandler(access)
                                    }
                                    val="326"
                                    class="circle_icon editApFinance"
                                  >
                                    <i class="iconSprites edit-icon">
                                      <div class="tooltip-sm"> Edit </div>
                                    </i>
                                  </a>
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="row mx-0 px-0">
            <div className="container px-0">
              <div className="top-header-sec py-3">
                <div class="row-fluid">
                  <div class="row pt-0 pb-1">
                    <div class="col-md-6 col-12 d-flex align-items-center">
                      <h3 class="event-alert p-0 mb-0">Cluster Stores</h3>
                    </div>
                    <div class="col-md-6 col-12 align-right pt-3 pt-md-0">
                      <button
                        className="btn green-btn-revert add-plus mx-0"
                        type="button"
                        onClick={() => {
                          if (selected_cluster_details == null) {
                            dispatch(
                              showAlert(
                                "Alert",
                                `Please add cluster details first!`
                              )
                            );
                          } else {
                            closeAddClusStoreModal(true);
                          }
                        }}
                      >
                        <i className="i-icon"> </i> Add Cluster Store
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="shadowclass py-0 mt-2">
                <div className="table-responsive">
                  <table className="checklist-table remove-space inventory_table m-0">
                    <thead>
                      <tr>
                        <th width="110px">Account ID</th>
                        <th width="200px">Account Name</th>
                        <th width="210px">Cluster Join Date</th>
                        <th>Cluster End date</th>
                        <th className="action-td"> Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      {checkArray(selected_cluster_details?.stores) &&
                        selected_cluster_details?.stores.map((store) => {
                          return (
                            <tr>
                              <td>{store?.id}</td>
                              <td>{store?.merchant?.full_name}</td>
                              <td>{store?.start_date}</td>
                              <td>{store?.end_date}</td>
                              <td className="action-td">
                                <a
                                  onClick={() => editClusStoreHandler(store)}
                                  val="326"
                                  class="circle_icon editApFinance"
                                >
                                  <i class="iconSprites edit-icon">
                                    <div class="tooltip-sm"> Edit </div>
                                  </i>
                                </a>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`Cluster Access Settings`}
        open={addClusSettingsModal}
        closeModal={closeAddClusSettingsModal}
        submitModal={addClusSettingsSubmit(submitAddClusSettingsHandler)}
        is_loading={is_add_cluster_settings_loading}
      >
        <form
          class=""
          enctype="multipart/form-data"
          id="AddEditClusterSetting"
          method="post"
          accept-charset="utf-8"
        >
          <div class="form-popup">
            <ul class="form-list label-group">
              <li class="full">
                <label
                  for="ClusterAccessSettingClusterModuleId"
                  class="required"
                >
                  Module
                </label>
                <div class="input-group select-div mb10">
                  <select
                    {...addClusSettingsReg("cluster_module_id")}
                    class="required clusmod"
                    id="ClusterAccessSettingClusterModuleId"
                    onChange={(event) =>
                      changeAddClusSettingsInputHandler(
                        "cluster_module_id",
                        event?.target?.value
                      )
                    }
                    value={addClusSettingsInputForm?.cluster_module_id}
                  >
                    <option value="">Select</option>
                    {checkArray(add_cluster_details?.modules) &&
                      add_cluster_details?.modules.map((module) => {
                        return (
                          <option value={module?.id}>{module?.name}</option>
                        );
                      })}
                  </select>{" "}
                  <ErrorContainer
                    errors={addClusSettingsErrors}
                    name="cluster_module_id"
                  />
                </div>
              </li>
              <li class="full">
                <label
                  for="ClusterAccessSettingClusterModuleMethodId"
                  class="required"
                >
                  Action
                </label>
                <div class="input-group select-div mb10">
                  <select
                    {...addClusSettingsReg("cluster_module_method_id")}
                    class="required clusact"
                    id="ClusterAccessSettingClusterModuleMethodId"
                    onChange={(event) =>
                      changeAddClusSettingsInputHandler(
                        "cluster_module_method_id",
                        event?.target?.value
                      )
                    }
                    value={addClusSettingsInputForm?.cluster_module_method_id}
                  >
                    <option value="">Select</option>
                    {checkArray(cluster_modules) &&
                      cluster_modules.map((cluster_module) => {
                        return (
                          <option value={cluster_module?.id}>
                            {cluster_module?.name}
                          </option>
                        );
                      })}
                  </select>{" "}
                  <ErrorContainer
                    errors={addClusSettingsErrors}
                    name="cluster_module_method_id"
                  />
                </div>
              </li>
              <li class="full">
                <label
                  for="ClusterAccessSettingAuthorityLevel"
                  class="required"
                >
                  Authority Level
                </label>
                <div class="input-group select-div mb10">
                  <select
                    {...addClusSettingsReg("authority_level")}
                    name="data[ClusterAccessSetting][authority_level]"
                    class="required"
                    id="ClusterAccessSettingAuthorityLevel"
                    onChange={(event) =>
                      changeAddClusSettingsInputHandler(
                        "authority_level",
                        event?.target?.value
                      )
                    }
                    value={addClusSettingsInputForm?.authority_level}
                  >
                    <option value="">Select</option>
                    {checkNull(add_cluster_details?.auth_levels, false) &&
                      Object.keys(add_cluster_details?.auth_levels).map(
                        (level) => {
                          return <option value={level}>{level}</option>;
                        }
                      )}
                  </select>{" "}
                  <ErrorContainer
                    errors={addClusSettingsErrors}
                    name="authority_level"
                  />
                </div>
              </li>
              <li>
                <div class="datePicker">
                  <label for="ClusterAccessSettingStartDate" class="required">
                    Effective Start Date
                  </label>{" "}
                  <DatePicker
                    {...addClusSettingsReg("start_date")}
                    name="start_date"
                    autoComplete="new-password"
                    dateFormat="yyyy-MM-dd"
                    onChange={(val) =>
                      changeAddClusSettingsInputHandler("start_date", val)
                    }
                    selected={addClusSettingsInputForm?.start_date}
                  />
                  <ErrorContainer
                    errors={addClusSettingsErrors}
                    name="start_date"
                  />
                </div>
              </li>
              <li>
                <div class="datePicker">
                  <label for="ClusterAccessSettingEndDate" class="required">
                    Effective End Date
                  </label>{" "}
                  <DatePicker
                    {...addClusSettingsReg("end_date")}
                    name="end_date"
                    autoComplete="new-password"
                    dateFormat="yyyy-MM-dd"
                    onChange={(val) =>
                      changeAddClusSettingsInputHandler("end_date", val)
                    }
                    selected={addClusSettingsInputForm?.end_date}
                  />
                  <ErrorContainer
                    errors={addClusSettingsErrors}
                    name="end_date"
                  />
                </div>
              </li>
            </ul>
          </div>
        </form>
      </ModelContainer>
      <ModelContainer
        title={`Add Cluster Store`}
        open={addClusStoreModal}
        closeModal={closeAddClusStoreModal}
        submitModal={addClusStoreSubmit(submitAddClusStoreHandler)}
        is_loading={is_add_cluster_store_loading}
      >
        <form
          class=""
          enctype="multipart/form-data"
          id="AddEditClusterStore"
          method="post"
          accept-charset="utf-8"
        >
          <div class="form-popup">
            <ul class="form-list label-group">
              <li class="full">
                <label for="ClusterAccessStoreAuthorityLevel" class="required">
                  Account
                </label>
                <div class="input-group select-div mb10">
                  <select
                    {...addClusStoreReg("merchant_id")}
                    class="required"
                    id="ClusterAccessStoreAuthorityLevel"
                    onChange={(event) =>
                      changeAddClusStoreInputHandler(
                        "merchant_id",
                        event?.target?.value
                      )
                    }
                    value={addClusStoreInputForm?.merchant_id}
                  >
                    <option value="">Select</option>
                    {checkNull(add_cluster_details?.accounts, false) &&
                      Object.keys(add_cluster_details?.accounts).map((acc) => {
                        return (
                          <option value={acc}>
                            {add_cluster_details?.accounts?.[acc]}
                          </option>
                        );
                      })}
                  </select>{" "}
                  <ErrorContainer
                    errors={addClusStoreErrors}
                    name="merchant_id"
                  />
                </div>
              </li>
              <li>
                <div class="datePicker">
                  <label for="ClusterAccessStoreStartDate" class="required">
                    Cluster Join Date
                  </label>{" "}
                  <DatePicker
                    {...addClusStoreReg("start_date")}
                    name="start_date"
                    autoComplete="new-password"
                    dateFormat="yyyy-MM-dd"
                    onChange={(val) =>
                      changeAddClusStoreInputHandler("start_date", val)
                    }
                    selected={addClusStoreInputForm?.start_date}
                  />
                  <ErrorContainer
                    errors={addClusStoreErrors}
                    name="start_date"
                  />
                </div>
              </li>
              <li>
                <div class="datePicker">
                  <label for="ClusterAccessStoreEndDate" class="required">
                    Cluster End Date
                  </label>{" "}
                  <DatePicker
                    {...addClusStoreReg("end_date")}
                    name="end_date"
                    autoComplete="new-password"
                    dateFormat="yyyy-MM-dd"
                    onChange={(val) =>
                      changeAddClusStoreInputHandler("end_date", val)
                    }
                    selected={addClusStoreInputForm?.end_date}
                  />
                  <ErrorContainer errors={addClusStoreErrors} name="end_date" />
                </div>
              </li>
            </ul>
          </div>
        </form>
      </ModelContainer>
    </UserInterface>
  );
};
export default AddCluster;
